import React from "react";
import { Link, useLocation } from "react-router-dom";

function Breadcrumbs() {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    return (
        <div className="breadcrumbs ace-save-state" id="breadcrumbs">
            <ul className="breadcrumb">
                <li>
                    <i className="ace-icon fa fa-home home-icon"></i>
                    <Link to="/">Home</Link>
                </li>
                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;

                    return isLast ? (
                        <li key={name} className="breadcrumb-item active">
                            {name}
                        </li>
                    ) : (
                        <li key={name} className="breadcrumb-item">
                            <Link to={routeTo}>{name}</Link>
                        </li>
                    );
                })}
            </ul>

        </div>
    );
}

export default Breadcrumbs;
